import { dataLayer } from 'analytics/data-layer';
import { getFeatureFlags } from 'utils/feature-flags';
import urls from 'constants/urls';
import { InterstitialsGA } from './types';

export function pushViewInterstitials({
  index,
  interstitialId,
  interstitialTitle,
  location,
  path,
}: InterstitialsGA) {
  dataLayer.push({
    event: 'view_interstitial',
    interstitial_id: interstitialId,
    interstitial_title: interstitialTitle,
    location,
    index,
    path,
  });
}

export function pushProceedInterstitials({
  index,
  interstitialId,
  interstitialTitle,
  location,
  path,
}: InterstitialsGA) {
  dataLayer.push({
    event: 'proceed_interstitial',
    interstitial_id: interstitialId,
    interstitial_title: interstitialTitle,
    location,
    index,
    path,
  });
}

export function pushCompleteInterstitials({ interstitialList }: { interstitialList: string[] }) {
  dataLayer.push({
    event: 'complete_interstitials',
    interstitial_list: interstitialList,
  });
}

export function pushViewMissedOffersInterstitial({
  offerDescription,
  offerId,
}: {
  offerDescription: string;
  offerId: string;
}) {
  dataLayer.push({
    event: 'view_offer',
    build_your_offer_status: 'incomplete',
    offer: offerDescription,
    offer_id: offerId,
  });
}

export function pushCompleteMissedOffersInterstitial({
  offerDescription,
  offerId,
}: {
  offerDescription: string;
  offerId: string;
}) {
  dataLayer.push({
    event: 'complete_build_your_offer',
    offer: offerDescription,
    offer_id: offerId,
  });
}

export function pushListInterstitials(interstitialList: string[]) {
  dataLayer.push({
    event: 'list_interstitials',
    interstitial_list: interstitialList,
  });
}

export function pushSkippedInterstitals({ checkoutRedirect }: { checkoutRedirect: string }) {
  const { EoS_interstitialsAnalytics: eosInterstitialsAnalytics } = getFeatureFlags();

  if (checkoutRedirect !== urls.checkout) return;
  if (!eosInterstitialsAnalytics) return;

  dataLayer.push({
    event: 'skipped_interstitials',
  });
}
